import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { __ } from "@wordpress/i18n";
import { WPQTPageHeader } from "../../components/common/Header/Header";
import { ArchiveContextProvider } from "../../providers/ArchiveContextProvider";
import { Page } from "../Page/Page";
import { Archive } from "./Archive/Archive";
function ArchivePage() {
    return (_jsx(ArchiveContextProvider, { children: _jsxs(Page, { children: [_jsx(WPQTPageHeader, { description: __("Archived tasks management page.", "quicktasker"), children: __("Archive", "quicktasker") }), _jsx(Archive, {})] }) }));
}
export { ArchivePage };
